import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useModal } from '../components/Modal'
import api from '../services/api'

export default function ChangePasswordPage() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const { showConfirm, ModalComponents } = useModal()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async e => {
    e.preventDefault()
    setError('')
    if (newPassword !== confirmPassword) { setError('ยืนยันรหัสผ่านใหม่ไม่ตรงกัน'); return }
    if (newPassword.length < 12 || new TextEncoder().encode(newPassword).length > 72) {
      setError('รหัสผ่านใหม่ต้องมีอย่างน้อย 12 ตัวอักษร และไม่เกิน 72 ไบต์')
      return
    }
    try {
      setSaving(true)
      await api.post('/auth/change-password', { current_password: currentPassword, new_password: newPassword })
      logout(false)
      navigate('/login', { replace: true, state: { passwordChanged: true } })
    } catch (err) {
      setError(err.response?.data?.message || 'ไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาลองใหม่')
    } finally { setSaving(false) }
  }

  const signOut = async () => {
    if (!(await showConfirm('info', 'ยืนยันออกจากระบบ', 'ต้องการออกจากระบบใช่หรือไม่?'))) return
    logout()
    navigate('/login', { replace: true })
  }

  const inputStyle = { width: '100%', padding: '12px', border: '1px solid #ccdef2', borderRadius: '10px', fontSize: '16px', boxSizing: 'border-box', marginTop: '6px' }
  return (
    <main style={{ minHeight: '100vh', background: '#f3f8ff', display: 'grid', placeItems: 'center', padding: '20px' }}>
      <ModalComponents />
      <div style={{ width: '100%', maxWidth: '440px', background: 'white', borderRadius: '18px', boxShadow: '0 12px 35px #1244801a', padding: '30px', boxSizing: 'border-box' }}>
        <h1 style={{ fontSize: '22px', color: '#0b3d91', margin: 0 }}>ตั้งรหัสผ่านของคุณ</h1>
        <p style={{ color: '#526e87', lineHeight: 1.6 }}>{user?.must_change_password ? 'เพื่อความปลอดภัย กรุณาเปลี่ยนรหัสชั่วคราวก่อนเข้าใช้งาน' : 'เปลี่ยนรหัสผ่านสำหรับบัญชีของคุณ'}</p>
        <form onSubmit={submit}>
          <label style={{ display: 'block', marginTop: '20px' }}>รหัสผ่านปัจจุบัน<input type="password" autoComplete="current-password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} style={inputStyle} required /></label>
          <label style={{ display: 'block', marginTop: '16px' }}>รหัสผ่านใหม่<input type="password" autoComplete="new-password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} required /></label>
          <label style={{ display: 'block', marginTop: '16px' }}>ยืนยันรหัสผ่านใหม่<input type="password" autoComplete="new-password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={inputStyle} required /></label>
          <p style={{ color: '#526e87', fontSize: '13px' }}>อย่างน้อย 12 ตัวอักษร ใช้รหัสที่เดายากและไม่ซ้ำกับรหัสเดิม</p>
          {error && <p role="alert" style={{ color: '#b91c1c' }}>{error}</p>}
          <button type="submit" disabled={saving} style={{ width: '100%', padding: '13px', border: 0, borderRadius: '10px', background: '#075dcc', color: 'white', cursor: 'pointer', fontSize: '15px' }}>{saving ? 'กำลังบันทึก...' : 'บันทึกรหัสใหม่'}</button>
        </form>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '18px' }}>
          {!user?.must_change_password && <button type="button" onClick={() => navigate(-1)} style={{ border: 0, color: '#075dcc', background: 'none', cursor: 'pointer' }}>กลับ</button>}
          <button type="button" onClick={signOut} style={{ border: 0, color: '#64748b', background: 'none', cursor: 'pointer', marginLeft: 'auto' }}>ออกจากระบบ</button>
        </div>
      </div>
    </main>
  )
}
